import React from "react";

const LoaderScreen = () => {
  return (
    <div className="loader-screen">
      <i className="fas fa-spin fa-spinner" />
    </div>
  );
};

export default LoaderScreen;
